// extracted by mini-css-extract-plugin
export var actionIcon = "_rv-0";